import LocalStorage from '../LocalStorage';

const key = 'redirect_after_login';

const RedirectAfterLogin = {
    set: (hasSeen: string): void => {
        LocalStorage.set(key, hasSeen);
    },

    get: (): string | null => {
        return LocalStorage.get(key);
    },

    remove: (): void => {
        LocalStorage.remove(key);
    },
};

export default RedirectAfterLogin;
